<template>
  <!-- eslint-disable max-len -->
  <transition name="fade">
    <div
      v-if="value"
      ref="modalContainer"
      class="c-modal"
      tabindex="0"
    >
      <div
        class="c-modal__backdrop"
        @click="$emit('input', false); $emit('user-dismissed');"
      />
      <div
        :class="dialogClass"
        class="c-modal__dialog"
      >
        <button
          v-if="closeX"
          :id="closeId"
          type="button"
          class="c-modal__close"
          @click="$emit('input', false); $emit('user-dismissed');"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.06487 7.50006L1.7409 2.17552C1.62082 2.05543 1.62082 1.86021 1.7409 1.73951C1.86097 1.62003 2.05617 1.62003 2.17625 1.73951L7.50022 7.06466L12.8248 1.73951C12.9443 1.62003 13.1395 1.62003 13.2596 1.73951C13.3796 1.86021 13.3796 2.05543 13.2596 2.17552L7.93558 7.50006L13.2596 12.8246C13.3796 12.9447 13.3796 13.1399 13.2596 13.2606C13.1992 13.3203 13.1204 13.3499 13.0416 13.3499C12.9627 13.3499 12.8839 13.3197 12.8236 13.2606L7.49961 7.93545L2.17563 13.2606C2.11529 13.3203 2.03647 13.3499 1.95765 13.3499C1.87883 13.3499 1.80001 13.3197 1.73967 13.2606C1.61959 13.1399 1.61959 12.9447 1.73967 12.8246L7.06364 7.50006H7.06487Z"
              fill="#004B87"
              stroke="#004B87"
              stroke-width="1.6"
            />
          </svg>
          <span class="sr-only">Close</span>
        </button>
        <slot />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    closeX: {
      type: Boolean,
      default: true,
    },
    dialogClass: {
      type: String,
      default: '',
    },
    closeId: {
      type: String,
      default: '',
      required: false,
    },
  },
  watch: {
    value(currentValue) {
      if (currentValue) {
        this.disablePageScrolling();
        this.$nextTick()
          .then(() => {
            this.$refs.modalContainer.focus();
          });
      } else {
        this.enablePageScrolling();
      }
    },
  },
  created() {
    if (this.value) {
      this.disablePageScrolling();
    }
  },
  beforeDestroy() {
    this.enablePageScrolling();
  },
  methods: {
    disablePageScrolling() {
      document.body.classList.add('overflow-hidden');
    },
    enablePageScrolling() {
      document.body.classList.remove('overflow-hidden');
    },
  },
};
</script>
